<div class="tnc-container">
  <iframe src="https://www.evolftech.com/terms-of-service-2/"
          style="width: 100%; height: 100vh; "></iframe>
</div>
